var defaultPreferencesDialogTemplate = {
    headings: [
        {
            key: 'allow',
            name: 'default_cookie_allow',
        },
        {
            key: 'category',
            name: 'default_cookie_category',
        },
    ],
    categories: [
        {
            key: 'functional',
            name: 'cookie_category_functional',
            description: 'cookie_description_functional',
            example: 'cookie_example_functional',
            types: [
                'CRM',
                'Custom',
                'Customer Success',
                'Deep Linking',
                'Helpdesk',
                'Livechat',
                'Performance Monitoring',
                'Personalization',
                'SMS & Push Notifications',
                'Security & Fraud',
            ],
        },
        {
            key: 'marketing',
            name: 'cookie_category_marketing',
            description: 'cookie_description_marketing',
            example: 'cookie_example_marketing',
            types: [
                'A/B Testing',
                'Analytics',
                'Attribution',
                'Braze Web Mode (Actions)',
                'Custom',
                'Email Marketing',
                'Enrichment',
                'Heatmaps & Recordings',
                'Other', // TODO: remove this when Segment bug is fixed https://segment.zendesk.com/hc/en-us/requests/517450
                'Raw Data',
                'Realtime Dashboards',
                'Referrals',
                'Surveys',
                'Video',
                'Webhooks',
            ],
        },
        {
            key: 'advertising',
            name: 'cookie_category_advertising',
            description: 'cookie_description_advertising',
            example: 'cookie_example_advertising',
            types: ['Advertising', 'Custom', 'Tag Managers'],
        },
    ],
};
export default defaultPreferencesDialogTemplate;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmYXVsdC1wcmVmZXJlbmNlcy10ZW1wbGF0ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb25zdHMvZGVmYXVsdC1wcmVmZXJlbmNlcy10ZW1wbGF0ZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFnQkEsSUFBTSxnQ0FBZ0MsR0FBNkI7SUFDakUsUUFBUSxFQUFFO1FBQ1I7WUFDRSxHQUFHLEVBQUUsT0FBTztZQUNaLElBQUksRUFBRSxzQkFBc0I7U0FDN0I7UUFDRDtZQUNFLEdBQUcsRUFBRSxVQUFVO1lBQ2YsSUFBSSxFQUFFLHlCQUF5QjtTQUNoQztLQUNGO0lBQ0QsVUFBVSxFQUFFO1FBQ1Y7WUFDRSxHQUFHLEVBQUUsWUFBWTtZQUNqQixJQUFJLEVBQUUsNEJBQTRCO1lBQ2xDLFdBQVcsRUFBRSwrQkFBK0I7WUFDNUMsT0FBTyxFQUFFLDJCQUEyQjtZQUNwQyxLQUFLLEVBQUU7Z0JBQ0wsS0FBSztnQkFDTCxRQUFRO2dCQUNSLGtCQUFrQjtnQkFDbEIsY0FBYztnQkFDZCxVQUFVO2dCQUNWLFVBQVU7Z0JBQ1Ysd0JBQXdCO2dCQUN4QixpQkFBaUI7Z0JBQ2pCLDBCQUEwQjtnQkFDMUIsa0JBQWtCO2FBQ25CO1NBQ0Y7UUFDRDtZQUNFLEdBQUcsRUFBRSxXQUFXO1lBQ2hCLElBQUksRUFBRSwyQkFBMkI7WUFDakMsV0FBVyxFQUFFLDhCQUE4QjtZQUMzQyxPQUFPLEVBQUUsMEJBQTBCO1lBQ25DLEtBQUssRUFBRTtnQkFDTCxhQUFhO2dCQUNiLFdBQVc7Z0JBQ1gsYUFBYTtnQkFDYiwwQkFBMEI7Z0JBQzFCLFFBQVE7Z0JBQ1IsaUJBQWlCO2dCQUNqQixZQUFZO2dCQUNaLHVCQUF1QjtnQkFDdkIsT0FBTyxFQUFFLG1HQUFtRztnQkFDNUcsVUFBVTtnQkFDVixxQkFBcUI7Z0JBQ3JCLFdBQVc7Z0JBQ1gsU0FBUztnQkFDVCxPQUFPO2dCQUNQLFVBQVU7YUFDWDtTQUNGO1FBQ0Q7WUFDRSxHQUFHLEVBQUUsYUFBYTtZQUNsQixJQUFJLEVBQUUsNkJBQTZCO1lBQ25DLFdBQVcsRUFBRSxnQ0FBZ0M7WUFDN0MsT0FBTyxFQUFFLDRCQUE0QjtZQUNyQyxLQUFLLEVBQUUsQ0FBQyxhQUFhLEVBQUUsUUFBUSxFQUFFLGNBQWMsQ0FBQztTQUNqRDtLQUNGO0NBQ0YsQ0FBQztBQUVGLGVBQWUsZ0NBQWdDLENBQUMifQ==